// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ClimateScenarioType;
(function (ClimateScenarioType) {
    ClimateScenarioType["CurrentPolicies"] = "CurrentPolicies";
    ClimateScenarioType["DelayedTransition"] = "DelayedTransition";
    ClimateScenarioType["NetZero2050"] = "NetZero2050";
    ClimateScenarioType["Ssp245"] = "Ssp245";
    ClimateScenarioType["Ssp370"] = "Ssp370";
    ClimateScenarioType["Ssp585"] = "Ssp585";
})(ClimateScenarioType || (ClimateScenarioType = {}));
export function ClimateScenarioTypeFromJSON(json) {
    return json;
}
export function ClimateScenarioTypeToJSON(value) {
    return value;
}
